const pageOp = {
  opNo: '按钮编码',
  opName:'按钮名称',
  opType:'按钮类型',
  remark:'备注',
  commonType:'公共按钮',
  customType:'自定义按钮',
  opType_0:'opType_0',
  opType_1:'opType_1',
  msg:{
    opNo:'请输入按钮编码',
    opName:"请输入按钮名称",
    opType:"请输选择按钮类型"
  }
};
export default pageOp



// WEBPACK FOOTER //
// ./src/page/auth/pageOp/lang/pageOp.zh.js